import { IVirtualManifestBuilderProps } from '@wix/editor-platform-manifest-services';
import { StylesDerivedNativeActionNames } from '@wix/editor-platform-host-integration-apis';
import { CompRef } from '@wix/document-services-types';
import actions from './actions';

import {
  EditorPointer,
  EditorPointerServiceAPI,
} from '@wix/editor-document-logic-api';

export const buildGlobalDesignContext = (
  _editorPointers: EditorPointer<CompRef>[],
  _actionName: StylesDerivedNativeActionNames,
  _editorPointerAPI: EditorPointerServiceAPI,
): IVirtualManifestBuilderProps['contextBuilder'] => {
  return (_builder) => {
    console.error('UNEXPECTED CALL');
    // TODO: remove - used only in global colors, global colors would be removed in the future and they will be implemented in the editor
    // editorPointers.forEach((editorPointer) => {
    //   builder.byEditorPointer(editorPointer, (manifest) => {
    //     if (!manifest) {
    //       return;
    //     }
    //
    //     const action = actions[actionName];
    //     return action.manifestProcessor(
    //       { editorElement: manifest },
    //       actionName,
    //       builder,
    //       editorPointer,
    //       editorPointerAPI,
    //     );
    //   });
    // });
  };
};
